"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropLauncherParam = dropLauncherParam;
exports.DropLauncherParam = DropLauncherParam;
const react_1 = require("react");
const launcher_1 = require("../../launcher/index.js");
function dropLauncherParam() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(launcher_1.LAUNCHER_PARAM))
        return;
    url.searchParams.delete(launcher_1.LAUNCHER_PARAM);
    window.history.replaceState(window.history.state, "", url);
}
function DropLauncherParam() {
    (0, react_1.useEffect)(dropLauncherParam, []);
    return null;
}
